/**
 * Attendance API Service
 */

import { apiClient } from '../client';
import type { ApiResponse, AttendanceStatus, AttendanceHistoryItem, ClockResult } from '../../types';

const API_PREFIX = '/api/saiens/attendance';

/**
 * Get today's attendance status
 */
export async function getAttendanceToday(): Promise<ApiResponse<AttendanceStatus>> {
  const response = await apiClient.get<ApiResponse<AttendanceStatus>>(
    `${API_PREFIX}/today`
  );
  return response.data;
}

/**
 * Clock in
 */
export async function clockIn(): Promise<ApiResponse<ClockResult>> {
  const response = await apiClient.post<ApiResponse<ClockResult>>(
    `${API_PREFIX}/clock-in`
  );
  return response.data;
}

/**
 * Clock out
 */
export async function clockOut(): Promise<ApiResponse<ClockResult>> {
  const response = await apiClient.post<ApiResponse<ClockResult>>(
    `${API_PREFIX}/clock-out`
  );
  return response.data;
}

/**
 * Get attendance history
 */
export async function getAttendanceHistory(
  days = 7
): Promise<ApiResponse<{ items: AttendanceHistoryItem[] }>> {
  const response = await apiClient.get<ApiResponse<{ items: AttendanceHistoryItem[] }>>(
    `${API_PREFIX}/history`,
    { params: { days } }
  );
  return response.data;
}
